import { createBrowserHistory } from 'history';
const basename = window?.ASCENDON_APP_CONFIG?.basename || '/';
const history = createBrowserHistory({ basename });
export default history;
